var map = {
	"./hisense/detection": 1022,
	"./lg/detection": 1023,
	"./nagra/detection": 1024,
	"./netrange/detection": 1025,
	"./opera/detection": 1026,
	"./ps4/detection": 1027,
	"./samsung/detection": 1028,
	"./seirobotics/detection": 1029,
	"./sony/detection": 1030,
	"./stbcoship/detection": 1031,
	"./tizen/detection": 1032,
	"./web0s/detection": 1033,
	"./workstation/detection": 1034,
	"./zeasn/detection": 1035
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1021;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/detection$
// module id = 1021
// module chunks = 0